import React, { CSSProperties, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { generateBackToLinkStyles } from 'shared-components/BackToLink/BackToLinkStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

type Props = {
    marginBottom?: string | number,
    marginLeft?: string | number,
    marginRight?: string | number,
    marginTop?: string | number,
    to?: string
}

const BackSvg = ({ style }: {style: CSSProperties}) => {
    const theme = useTheme();

    return (
        <svg
            style={style}
            width="8" height="8" viewBox="0 0 8 8" fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 3.5H1.915L4.71 0.705L4 0L0 4L4 8L4.705 7.295L1.915 4.5H8V3.5Z"
                fill={theme.palette.primary.main}
            />
        </svg>
    );
};

const BackToLink = ({
    marginBottom = 10,
    marginLeft = 0,
    marginRight = 0,
    marginTop = 10,
} : Props) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const styles = useMemo(() => generateBackToLinkStyles(theme), [theme]);

    return (
        <Box sx={styles.wrapper}>
            <Link
                to="/"
                style={{
                    marginBottom,
                    marginLeft,
                    marginRight,
                    marginTop,
                    color: theme.palette.primary.main,
                }}
                onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                }}
            >
                <BackSvg style={{
                    marginRight: '5px' }}
                />
                <span style={{
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '16px',
                    letterSpacing: '0.25px',
                    color: theme.palette.primary.main,
                }}
                >
                    Back
                </span>
            </Link>
        </Box>
    );
};

export default BackToLink;
